import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Configuration from "../configuration";
var token = localStorage.getItem("x-access-token");




export const fetchSimulation = createAsyncThunk("simulation/allSimulation", async () => {
  const response = await fetch(Configuration.BACK_BASEURL + "simulation/allSimulation", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },

  });
  const simulation = await response.json();
  return simulation;
});



export const fetchSimulationForListe = createAsyncThunk("simulation/allSimulationForList", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "simulation/allSimulationForList", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)
  });
  const simulation = await response.json();
  return simulation;
});



export const checkProduit = createAsyncThunk("simulation/checkProduit", async (action) => {

  const response = await fetch(Configuration.BACK_BASEURL + "simulation/checkProduit", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token // Make sure 'token' is defined
    },
    body: JSON.stringify(action)
  });
  const simulation = await response.json();
  return simulation;
});


//upload BL file
export const saveFile = createAsyncThunk("simulation/saveFile", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "simulation/saveFile", {
    method: 'POST',
    headers: {
      'Accept': 'application/*',
      'x-access-token': token,
    },
    body: action
  });
  const simulation = await response.json();
  return simulation;
});



export const simulationMois = createAsyncThunk("simulation/simulationMois", async (action) => {
  // console.log(action)
  const response = await fetch(Configuration.BACK_BASEURL + "simulation/simulationMois", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)
  });
  const simulation = await response.json();
  return simulation;
});



export const AddedExcel = createAsyncThunk("simulation/enteteAddedExcel", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "simulation/enteteAddedExcel", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)
  });
  const simulation = await response.json();
  return simulation;
});


// for export excel
export const fetchSimulationOnly = createAsyncThunk("simulation/allhisSimulation", async (action) => {
  console.log(action)
  const response = await fetch(Configuration.BACK_BASEURL + "simulation/allhisSimulation", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)
  });
  const simulation = await response.json();
  return simulation;
});



export const SimulationDeleted = createAsyncThunk("simulation/delete", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "simulation/delete/" + action.id, {
    method: 'DELETE',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
  });
  const simulation = await response.json();
  return simulation;
});


export const verifExistance = createAsyncThunk("simulation/verifExistance", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "simulation/verifExistance", {
      method: 'POST',
      headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'x-access-token': token
      },
      body: JSON.stringify(action)
  });
  const simulation = await response.json();
  return simulation;
});


export const verifEntete = createAsyncThunk("simulation/verifEntete", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "simulation/verifEntete", {
      method: 'POST',
      headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'x-access-token': token
      },
      body: JSON.stringify(action)
  });
  const simulation = await response.json();
  return simulation;
}); 
const simulationReduce = createSlice({
  name: "simulation",
  initialState: {
    entities: [],
    loading: false,
  },
  reducers: {
  },
  extraReducers: {
  },
});


export default simulationReduce.reducer;